import logOutIcon from "../../assets/icon/material-symbols_logout.svg";
import logo from "../../assets/img/Logo_arunika.png";
import { NavLink, useNavigate } from "react-router-dom";
import { clearAuthSession, getAuthUser } from "../../api/authApi";
import { getMenusForRole } from "./menuConfig";

function useLogout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (!confirmed) return;

    // JWT stateless -> cukup hapus token di client, tidak perlu hit
    // endpoint backend. Kalau nanti ada mekanisme token blacklist/refresh
    // token di server, tambahkan call API logout di sini sebelum clear.
    clearAuthSession();

    navigate("/login", { replace: true });
  };

  return { handleLogout };
}

export default function Sidebar() {
  const { handleLogout } = useLogout();
  const menus = getMenusForRole(getAuthUser()?.role);

  return (
    <aside className="w-[275px] bg-white rounded-[30px] p-8 shadow-sm flex flex-col">
      <img src={logo} className="h-auto w-auto mx-auto mb-12" />

      <nav className="space-y-2 flex-1">
        {menus.map((item) => (
          <NavLink
            key={item.title}
            to={item.path}
            className={({ isActive }) =>
              `w-full flex items-center gap-4 px-4 py-3 rounded-xl transition ${
                isActive ? "bg-gray-100 font-semibold" : "hover:bg-gray-50"
              }`
            }>
            <img src={item.icon} alt={item.title} className="w-5 h-5" />

            <span>{item.title}</span>
          </NavLink>
        ))}
      </nav>

      <button
        onClick={handleLogout}
        className="mt-10 bg-red-600 text-white rounded-lg py-3 flex justify-center items-center gap-2 hover:bg-red-700">
        Logout
        <img src={logOutIcon} alt="Logout" />
      </button>
    </aside>
  );
}
